import React, { useEffect, useRef, useState } from "react";
 
export default function ({callback}) {
  const turnstileRef = useRef(null);
 
  useEffect(() => {
    const loadTurnstile = () => {
      if (!window.turnstile || !turnstileRef.current) return;

      window.turnstile.render(turnstileRef.current, {
        callback,
        theme: "light",
      });
    };

    var _has_script = document.getElementById("cf-turnsite");

    if (!_has_script) {
      var script = document.createElement("script");
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.onload = loadTurnstile;
      script.id = "cf-turnsite";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div id="cf-turnsite-container" className="uk-margin-top">
      <div ref={turnstileRef} data-sitekey="0x4AAAAAABnKK2PYwXftELQ3"></div>
    </div>
  );
};
